import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { authenticatedGuard } from './guards/authenticated.guard';
import { Role } from './common/enums/role.enum';
import { roleGuard } from './guards/role.guard';
import { redirectGuard } from './guards/redirect.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/presentation/presentation.component').then(
        (m) => m.PresentationComponent,
      ),
    canActivate: [authenticatedGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
    canActivate: [authenticatedGuard],
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/register.component').then(
        (m) => m.RegisterComponent,
      ),
    canActivate: [authenticatedGuard],
  },
  {
    path: 'home/user',
    loadComponent: () =>
      import('./pages/home-user/home-user.component').then(
        (m) => m.HomeUserComponent,
      ),
  },
  {
    path: 'invalid-url',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
  },
  {
    path: 'home/admin',
    loadComponent: () =>
      import('./pages/home-admin/home-admin.component').then(
        (m) => m.AdminTestComponent,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      roles: [Role.ADMIN, Role.SUPERVISOR],
    },
  },
  {
    path: 'products',
    loadComponent: () =>
      import('./pages/products/products.component').then(
        (m) => m.ProductsComponent,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      roles: [Role.ADMIN, Role.SUPER_ADMIN],
    },
  },
  {
    path: 'projects',
    loadComponent: () =>
      import('./pages/projects/projects.component').then(
        (m) => m.ProjectsComponent,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      roles: [Role.ADMIN, Role.SUPER_ADMIN],
    },
  },
  {
    path: 'classes',
    loadComponent: () =>
      import('./pages/classes/classes.component').then(
        (m) => m.ClassesComponent,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      roles: [Role.ADMIN, Role.SUPER_ADMIN],
    },
  },
  {
    path: 'image-browser',
    loadComponent: () =>
      import('./pages/image-browser/image-browser.component').then(
        (m) => m.ImageBrowserComponent,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      roles: [Role.ADMIN, Role.SUPERVISOR],
    },
  },
  {
    path: '**',
    canActivate: [redirectGuard],
    loadComponent: () =>
      import('./pages/home-user/home-user.component').then(
        (m) => m.HomeUserComponent,
      ),
  },

];
